import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import { LoginPopupStyles } from '../../components/common/popup/LoginPopup';
import LoginPopup from '../../components/common/popup/LoginPopup';
import { setUserBrandAddAction, setUserBrandDelAction } from '../../modules/common/brandModule';
import { setClipBrandIdAction } from '../../modules/su/userBrandModule';
import { remove } from 'lodash';
import { isMobileOnly } from 'react-device-detect';

const BrandHomeHeaderBlock = styled.div`
    .line-brand {
        width: 100%;
        height: 1px;
        border-bottom: solid 1px #707070;
    }

    ${isMobileOnly?`
    padding: 30px 0px;
    `:`

    `};

    .container-left {
        float: left;
    }
    .container-right {
        float: right;
        width: calc(100% - 100px);
        padding-top: 15px;
    }
`;

const BrandHomeThumBlock = styled.div`
    ${isMobileOnly?`
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 10px;
    background-size: 90px 90px;
    `:`
    width: 140px;
    height: 140px;
    border-radius: 70px;
    margin-bottom: 30px;
    background-size: 140px 140px;
    `};
    
    background-image : url(${props => props.backgroundimage});
    background-position: center;
`;

const BrandHomeHeaderInfoLikeButtonBlock = styled.button`
    width: 32px;
    height: 33px;
    background: ${props => props.btnUrl};
    background-size: 18px 18.8px;
`;

const BrBrandHomeHeaderInfoH2Block = styled.h2`
    ${isMobileOnly?`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2;
    color: #333333;
    margin-bottom: 4px;
    padding: 8px 0;
    `:`
    font-size: 22px;
    font-weight: 500;
    line-height: 1.2;
    padding: 3px 0;
    color: #333333;
    `};

    
    width: calc(100% - 40px);
`;

const BrBrandHomeHeaderInfoPBlock = styled.p`
    ${isMobileOnly?`
    line-height: 1.33;
    font-size: 12px;
    color: #666666;
    `:`
    line-height: 1.54;
    font-size: 13px;
    color: #666666;
    `};

`;

const BrBrandHomeHeader = ({ imgHeader, imgLogo, imgLevel, brandTitle, brandInfo, idHome, imgThum }) => {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [isClipAdd, setIsClipAdd] = useState(false);
    const [isClipDel, setIsClipDel] = useState(false);
    const [fromLoginPU, setFromLoginPU] = useState(false);

    const { accessToken, clipBrandIds, brandClipResult, id } = useSelector(
        ({ userReducer, brandItemsReducer, userBrandReducer }) => ({
            accessToken: userReducer.accessToken,
            clipBrandIds: userBrandReducer.clipBrandIds,
            brandClipResult: brandItemsReducer.brandClipResult,
            id: userReducer.id,
        })
    );

    useEffect(() => {
        if (accessToken !== null) {
            // console.log("BrBrandHomeHeader oncloseModal")
            onCloseModal();
        }

        return () => {
            // console.log("BrBrandHomeHeader end = ");
        };

    }, [accessToken]);

    useEffect(() => {

        //console.log("BrBrandHomeHeader" + JSON.stringify(clipBrandIds))

        if (isClipAdd) {
            if (clipBrandIds === null || clipBrandIds === undefined || (clipBrandIds && clipBrandIds.length < 1)) {
                let clipSum = [];
                clipSum.push(idHome);
                //console.log("BrBrandHomeHeader" + JSON.stringify(clipSum))
                dispatch(setClipBrandIdAction(clipSum));
                setIsClipAdd(false);
            }
            else {
                let clipSum = [...new Set(clipBrandIds.concat(idHome))];
                //console.log("BrBrandHomeHeader" + JSON.stringify(clipSum))
                dispatch(setClipBrandIdAction(clipSum));
                setIsClipAdd(false);
            }
        }
        else if (isClipDel) {
            if (clipBrandIds != null) {
                let clipSum = [...clipBrandIds];
                remove(clipSum, (obj) => { return obj === idHome })
                //console.log("BrBrandHomeHeader" + JSON.stringify(clipSum))
                dispatch(setClipBrandIdAction(clipSum));
                setIsClipDel(false);
            }
        }

    }, [brandClipResult]);

    //로그인 팝업 뜨고 로그인 완료 후, 좋아요 리스트 요청(메인화면에서 요청) 후 처리.
    useEffect(() => {
        if (accessToken !== null && fromLoginPU === true) {

            //로그인 완료 후 이미 좋아요 포함되어 있는 경우 요청하지 않음.
            if (clipBrandIds != null && clipBrandIds.length > 0 && clipBrandIds.includes(idHome)) {

            }
            else {

                dispatch(setUserBrandAddAction(id, idHome));
                setIsClipAdd(true);
                setIsClipDel(false);
            }
            setFromLoginPU(false);
        }

    }, [clipBrandIds]);

    const onOpenModal = () => {
        setOpenModal(true);
    }

    // Modal 닫기
    const onCloseModal = () => {
        setOpenModal(false);
    }

    const onHandleLike = (idHome) => {
        //비로그인
        if (accessToken === null) {
            onOpenModal();
            setFromLoginPU(true); //로그인 팝업 후, 종료시 다시 요청하기 위해서..
        }
        else {
            if (clipBrandIds != null && clipBrandIds.length > 0 && clipBrandIds.includes(idHome)) {
                dispatch(setUserBrandDelAction(id, idHome));
                setIsClipAdd(false);
                setIsClipDel(true);
            }
            else {
                dispatch(setUserBrandAddAction(id, idHome));
                setIsClipAdd(true);
                setIsClipDel(false);
            }
        }

    }

    const getLikeBtn = () => {

        //비로그인
        if (accessToken === null) {
            return "url(/assets/images/icon/bookmark-icon-gray.png) center center/cover no-repeat"
        }
        else {
            if (clipBrandIds != null && clipBrandIds.length > 0 && clipBrandIds.indexOf(idHome) > -1) {
                return "url(/assets/images/icon/bookmark-icon-trans-icon.png) center center/cover no-repeat"
            }
            else {
                return "url(/assets/images/icon/bookmark-icon-gray.png) center center/cover no-repeat"
            }

        }
        //return "url(/assets/images/icon/bookmark-icon-active.png) center center/cover no-repeat"
    }

    return (
        isMobileOnly?
        <BrandHomeHeaderBlock className="clearfix" >
            <div className="container-left">
                <BrandHomeThumBlock backgroundimage={imgThum.replace(/ /g, "%20")} />
            </div>
            <div className="container-right">
                <div className="clearfix">
                    <BrBrandHomeHeaderInfoH2Block className="f-left">
                                    {brandTitle}
                    </BrBrandHomeHeaderInfoH2Block>
                    <BrandHomeHeaderInfoLikeButtonBlock className="f-right" onClick={() => onHandleLike(idHome)}
                    btnUrl={getLikeBtn()} >
                    </BrandHomeHeaderInfoLikeButtonBlock>
                </div>
                <div >
                    <BrBrandHomeHeaderInfoPBlock>
                    {brandInfo}
                    </BrBrandHomeHeaderInfoPBlock>
                </div>
            </div>
            
            <Modal
            isOpen={openModal}
            onRequestClose={onCloseModal}
            style={LoginPopupStyles}
            onAfterOpen={() => document.body.style.overflow = 'hidden'}
            onAfterClose={() => document.body.removeAttribute('style')}>
            <LoginPopup onClosePopup={onCloseModal}/>
        </Modal>
        </BrandHomeHeaderBlock>
        :
        <BrandHomeHeaderBlock className="margin_b-30" >
            <BrandHomeThumBlock backgroundimage={imgThum.replace(/ /g, "%20")} />
            <div className="margin_b-10 clearfix">
                <BrBrandHomeHeaderInfoH2Block className="f-left">
                                {brandTitle}
                </BrBrandHomeHeaderInfoH2Block>
                <BrandHomeHeaderInfoLikeButtonBlock className="f-right" onClick={() => onHandleLike(idHome)}
                btnUrl={getLikeBtn()} >
                </BrandHomeHeaderInfoLikeButtonBlock>
            </div>
            <div className="margin_b-30">
                <BrBrandHomeHeaderInfoPBlock>
                {brandInfo}
                </BrBrandHomeHeaderInfoPBlock>
            </div>
            <div className="line-brand" />
            <Modal
            isOpen={openModal}
            onRequestClose={onCloseModal}
            style={LoginPopupStyles}
            onAfterOpen={() => document.body.style.overflow = 'hidden'}
            onAfterClose={() => document.body.removeAttribute('style')}>
            <LoginPopup onClosePopup={onCloseModal}/>
        </Modal>
        </BrandHomeHeaderBlock>
    );
};

export default BrBrandHomeHeader;
